import { createSlice } from '@reduxjs/toolkit';
import { INPUT_PARAM_DEFAULTS } from '../../components/WdValidator/constants';

const wdValidatorSlice = createSlice({
	name: 'wdValidator',
	slice: 'wdValidator',
	initialState: {
		inputParameters: {
			vinMin: '',
			vinMax: '',
			vout: '',
			iout: '',
			ambientTemperature: INPUT_PARAM_DEFAULTS.AMB_TEMP,
			supplyType: '',
			lineFrequency: INPUT_PARAM_DEFAULTS.LINE_FREQUENCY,
			isolated: INPUT_PARAM_DEFAULTS.ISOLATED
		}
	},
	reducers: {
		setInputParameters(state, action) {
			const inputParameters = {};

			Object.keys(state.inputParameters).forEach(ipKey => {
				const newValue = action.payload[ipKey];
				inputParameters[ipKey] = newValue === null ? '' : newValue;
			});
			state.inputParameters = inputParameters;
		}
	}
});
export const { setInputParameters } = wdValidatorSlice.actions;
export default wdValidatorSlice.reducer;
